import { mapGetters } from 'vuex';
import { eventBus } from '@/utils/event';

export default {
  name: 'App',

  data() {
    return {};
  },

  computed: {
    ...mapGetters(['inviteCode']),
  },

  mounted() {
    const inviteCode = this.inviteCode || '';
    
    eventBus.$off('relogin');
    eventBus.$on('relogin', () => {
      this.$message({
        message: 'Login expired, please log in again.',
        type: 'error',
        showClose: true,
        customClass: 'custom-message',
      });
      
      localStorage.setItem('user_token', '');
      this.$store.dispatch('updateUserToken', {
        userToken: ''
      });
      this.$store.dispatch('updateUserInfo');
      setTimeout(() => {
        this.$router.push({
          path: '/login',
          query: {
            invite_code: this.inviteCode,
          }
        });
      }, 100);
    });
  }
}